export const globalEnvironment = {
    production: false,
    instrumentationKey: "499edcc6-2861-4bdb-9788-0de711babfbf",
    googleGeolocationKey: "AIzaSyDGj7ft-u2u3vk34vATm8B0tewuWfGLOMg",
    globalI18nFiles: ["global", "countries", "libs", "languages"],
};
